import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WalletPointsTransactionService } from './services/wallet-points-transaction.service';
import { EmployeePointsByMonth, EmployeePointsHistory } from './model/wallet-points-transactions';
import { ListingModel } from '../../features/companies/enum/company';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-wallet-points-transactions',
  templateUrl: './wallet-points-transactions.component.html'
})
export class WalletPointsTransactionsComponent {

  @Input() id!: string;
  @Input() currentPoints!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();


  employeePoints: EmployeePointsHistory[] = []
  employeePointsLoading = false;
  historyListingModel: ListingModel = new ListingModel;
  employeeHistoryByMonthListingModel!: any;

  employeePointsByMonthLoading = false;

  today = new Date();
  sessionRequestID!: string;

  constructor(private service: WalletPointsTransactionService,
    public _authService: AuthenticationService
  ) {
  }


  ngOnInit(): void {
    this.EmployeePointsHistory();
  }

  EmployeePointsHistory() {
    this.employeePointsLoading = true;
    let model = { ...this.historyListingModel };
    model.page += 1;
    this.service.EmployeePointsHistory(this.id).subscribe((res: any) => {
      this.employeePoints = this.employeePoints.concat(res.data.list);
      this.employeePointsLoading = false;
    })
  }

  onOpenExpansion(i: any) {
    this.employeePoints[i].page = 1;
    this.employeePoints[i].dataList = [];
  }

  getEmployeeHistoryByMonth(year_and_month: any, i: number) {
    // let model = { ...this.employeeHistoryByMonthListingModel };
    let model = {
      perPage: 10,
      year_and_month: year_and_month,
      page: this.employeePoints[i].page || 1,
      employee_id: this.id
    }
    this.employeePoints[i].loading = true;
    this.service.GetEmployeePointsHistoryByMonth(model).subscribe((res: any) => {
      this.employeePoints[i].loading = false;
      this.employeePoints[i].pagination = res.data.pagination;
      this.employeePoints[i].total = res.data.total;
      if (!this.employeePoints[i].dataList) {
        this.employeePoints[i].dataList = [];
      }
      this.employeePoints[i].dataList = this.employeePoints[i].dataList.concat(res.data.list)
      this.employeePoints[i].dataList.map((item) => {
        item.isShow = false;
      });
    })
  }

  getNextPage(year_and_month: any, i: number) {
    // console.log(this.employeePoints[i].total)
    if (this.employeePoints[i].loading) return;
    if (this.employeePoints[i].dataList.length < this.employeePoints[i].total) {
      this.employeePoints[i].page += 1;
      this.getEmployeeHistoryByMonth(year_and_month, i);
    }
  }

  ShowHideDetails(i: any, x: any, isShow: boolean) {
    let target = this.employeePoints[i].dataList[x];
    target.isShow = isShow;
    this.updateExpireAter(target)
    window.setInterval(() => {
      this.updateExpireAter(target)
    }, 1000)
  }

  updateExpireAter(target: any) {
    if (target.message.expire_after > 0) {
      target.message.expire_after = target.message.expire_after - 1;
      target.timer = this.getElapsedTime(target.message.expire_after);
    }
  }


  getElapsedTime(allSeconds: number) {
    let minutes = 0;
    let seconds = 0;
    let totalSeconds = allSeconds;

    if (allSeconds < 0) {
      totalSeconds = Math.abs(allSeconds);
    }

    let m = '00', s = '00';

    if (totalSeconds >= 60) {
      minutes = Math.floor(totalSeconds / 60);
      m = minutes > 9 ? "" + minutes : "0" + minutes;
      totalSeconds -= 60 * minutes;
    }

    seconds = totalSeconds;
    s = seconds > 9 ? "" + seconds : "0" + seconds;

    return { m, s };
  }
}
